import {
  Contact,
  ContactsByHabitatQueryVariables,
  ListContactsQueryVariables,
} from '@akin-home/amplify';
import { ContactModel, sortByName } from '@akin-home/contacts';

import {
  formatToContactModel,
  getContactQuery,
  listAllContactsForHabitatQuery,
  listAllContactsQuery,
} from '@akin-home/contacts/frontend';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { contactsQueryKeySet } from './query_key';

/** Query hook to get a single contact */
export const useGetContactQuery = (id?: string, options?: any) =>
  useQuery<Contact, unknown, ContactModel>(
    contactsQueryKeySet.detail(id),
    async () => (await getContactQuery({ id })).data.getContact as Contact,
    {
      enabled: !!id,
      select: (contact) => formatToContactModel(contact),
      ...options,
    }
  );

export const useListAllContacts = (params?: ListContactsQueryVariables) =>
  useQuery(contactsQueryKeySet.list(params), () =>
    listAllContactsQuery(params)
  );

export const useListContactsByHabitat = (
  params?: ContactsByHabitatQueryVariables
) =>
  useQuery(contactsQueryKeySet.list(params), () =>
    listAllContactsForHabitatQuery(params)
  );

export const useListAllContactModels = (
  params?: ListContactsQueryVariables
) => {
  const { data, ...result } = useListAllContacts(params);

  const contacts = useMemo(() => data?.map(formatToContactModel) || [], [data]);

  return {
    ...result,
    data: contacts,
  };
};

/** Hook to list all contacts for a given habitat */
export const useListContactsForHabitat = (habitatID: string) => {
  const { data, ...result } = useListContactsByHabitat({ habitatID });

  const contacts = useMemo(
    () => sortByName(data?.map(formatToContactModel)) || [],
    [data]
  );

  return {
    ...result,
    data: contacts,
  };
};
